import { Icon } from "../../../Icon";
import moment from "moment";
import Label from "../../../Label";
import Modal from "../../../common/Modal/Modal";
import useModal from "../../../../utils/hooks/useModal";
import { useState } from "react";
import { AdminService } from "../../utils";
import { useAsync } from "../../../../utils/hooks/useAsync";
import ConfigSelect from "../../AddProduct/ConfigSelect";
import { toast } from "react-toastify";
import Category from "../../../../pages/category";
import { clearAllBodyScrollLocks } from "body-scroll-lock";

type Props = {
  categories: Category[];

  deleteCategory: (department: string, value: string, id: string) => void;
  updateCategory: (category: Category) => void;
};

const CategoryList: React.FC<Props> = ({
  categories,
  deleteCategory,
  updateCategory,
}) => {
  const { isOpen, toggle } = useModal();

  const { isSuccess, isLoading, run } = useAsync();
  const emptyCategory = {
    value: "",
    label: "",
    department: "",
    description: false,
    ts: 0,
  };
  const [categoryEdit, setCategoryEdit] = useState<Category>(emptyCategory);
  const handleDelete = (department: string, value: string, id: string) => {
    deleteCategory(department, value, id);
  };

  const handleChange = (e: any) => {
    !e.currentTarget
      ? setCategoryEdit({
          ...categoryEdit,
          description: e.value == "true" ? true : false,
        })
      : setCategoryEdit({
          ...categoryEdit,
          [e.currentTarget.name]: e.currentTarget.value,
        });
  };
  const childrenEdit = (category: Category) => (
    <div className="childrenEdit" style={{ backgroundColor: "#f4f4f4" }}>
      <div className="childrenEdit_Header">
        <h2 className="childrenEdit_Header__title">Editar categoría</h2>
        <div onClick={toggle}>
          <Icon iconName="close_icon" className="childrenEdit_Header__close" />
        </div>
      </div>
      <label>
        Nombre:
        <input
          type="text"
          name="label"
          id="label"
          onChange={handleChange}
          value={categoryEdit.label}
        />
      </label>

      <ConfigSelect
        handleSelect={handleChange}
        placeholder="Seleccionar..."
        value={{
          value: category.description.toString(),
          label:
            category.description.toString() === ""
              ? "Seleccionar..."
              : category.description.toString() === "true"
              ? "Con descripción"
              : "Sin descripción",
        }}
        options={[
          { value: "true", label: "Con descripción" },
          { value: "false", label: "Sin descripción" },
        ]}
        productConfig="description"
        label="Descripción:"
      />
      <div className="childrenDelete_Buttons">
        <button
          type="button"
          className="childrenDelete_Buttons_Cancel"
          onClick={handleCancel}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="childrenDelete_Buttons_Navigate"
          onClick={() => handleSubmitEdit(categoryEdit)}
        >
          Guardar
        </button>
      </div>
    </div>
  );

  const handleCancel = () => {
    toggle();
    clearAllBodyScrollLocks();
  };

  const handleSubmitEdit = (category: Category) => {
    updateCategory(category);
    toggle();
    clearAllBodyScrollLocks();
  };
  const handleEdit = (cat: Category) => {
    setCategoryEdit(cat);
    toggle();
  };

  return (
    <>
      <Label
        tag="h3"
        className="manufacturingCostTitle"
        style={{
          textAlign: "left",
          fontFamily: "Mont-Semibold",
          marginBottom: "1.5rem",
        }}
      >
        Categorías
      </Label>

      {categories.map((cat) => {
        return (
          <>
            <div
              className="listManufacturingCost"
              key={cat.value + cat.department}
            >
              <h5
                className="listManufacturingCost_short_button"
                style={{
                  backgroundColor: "#EBEBEC",
                  color: "black",
                  fontSize: "11px",
                  fontFamily: "Mont-Semibold",
                  width: "90px",
                }}
              >
                {cat.department == "chain"
                  ? "Cadenas"
                  : cat.department == "brazalete"
                  ? "Pulseras"
                  : cat.department == "ring"
                  ? "Anillos"
                  : cat.department === "hoop"
                  ? "Aros"
                  : cat.department === "finding"
                  ? "Fornituras"
                  : "Dijes"}
              </h5>

              <h5 className="listManufacturingCost_mid">
                {cat.label.toUpperCase()}
              </h5>
              <h5 className="listManufacturingCost_mid">
                {cat.description ? "Con descripción" : "Sin descripción"}
              </h5>
              <h5 className="listManufacturingCost_long">
                {moment.unix(cat.ts).format("MM/DD/YYYY")}
              </h5>
              <button
                className="listManufacturingCost_button_edit"
                style={{ paddingRight: "4px" }}
                type="button"
                onClick={() => handleEdit(cat)}
              >
                <Icon iconName="edit_icon" />
              </button>
              <button
                className="listManufacturingCost_button_edit"
                type="button"
                onClick={() =>
                  handleDelete(
                    cat.department,
                    cat.value,
                    cat._id ? cat._id : ""
                  )
                }
              >
                <Icon iconName="trash_cart" />
              </button>
            </div>
          </>
        );
      })}
      {isOpen && (
        <Modal
          isOpen={true}
          style={{ backgroundColor: "#f4f4f4" }}
          toggle={toggle}
          children={childrenEdit(categoryEdit)}
        />
      )}
    </>
  );
};

export default CategoryList;
